import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '@/redux/store';
import * as api from '../api';
import { setError } from '../../../redux/slice';
import { doGetClaims } from '../../../modules/claims/stores/thunk';

interface ConfirmInactiveOrderParams {
  orderId: string;
  action: string;
}

interface PerformOrderActionParams {
  orderId: string;
  action: string;
  extraInput?: {
    notes: string;
    date: Date;
  };
}

interface CreateClaimDto {
  orderId: string;
  orderValue: number;
}

export const doGetInactiveOrders = createAsyncThunk<any, undefined, { state: RootState }>(
  'orders/doGetInactiveOrders',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.getInactiveOrders(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : 'Unknown error occurred';
      return thunkAPI.rejectWithValue({ message: errorMessage });
    }
  },
);

export const doGetIncorrectlyFailedOrders = createAsyncThunk<any, undefined, { state: RootState }>(
  'orders/doGetIncorrectlyFailedOrders',
  async (_, thunkAPI) => {
    try {
      const { response, error } = await api.getIncorrectlyFailedOrders();
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : 'Unknown error occurred';
      return thunkAPI.rejectWithValue({ message: errorMessage });
    }
  },
);

export const doConfirmInactiveOrder = createAsyncThunk<any, ConfirmInactiveOrderParams, { state: RootState }>(
  'orders/doConfirmInactiveOrder',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.confirmInactiveOrder(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        //thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
        return response;
      }
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : 'Unknown error occurred';
      thunkAPI.dispatch(setError({ message: errorMessage }));
      return thunkAPI.rejectWithValue({ message: errorMessage });
    }
  },
);

export const doPerformOrderAction = createAsyncThunk<any, PerformOrderActionParams, { state: RootState }>(
  'orders/doPerformOrderAction',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.performOrderAction(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        //thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
        return response;
      }
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : 'Unknown error occurred';
      thunkAPI.dispatch(setError({ message: errorMessage }));
      return thunkAPI.rejectWithValue({ message: errorMessage });
    }
  },
);

export const doCreateClaim = createAsyncThunk<any, CreateClaimDto, { state: RootState }>(
  'orders/doCreateClaim',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.createClaim(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        await thunkAPI.dispatch(doGetClaims({ page: 1, take: 10 }));
        return response;
      }
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : 'Unknown error occurred';
      thunkAPI.dispatch(setError({ message: errorMessage }));
      return thunkAPI.rejectWithValue({ message: errorMessage });
    }
  },
);
